export default __webpack_public_path__ + "static/media/sww2.d35320c3.png";